import { requst } from '../config'

// 日历上数据
export const getROVCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/rov/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getROVDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 查询日期
export const getROVByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/rov/date?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 查询 id
export const getROVByIdApi = id => {
    const url = `/monitor/rov/${id}`
    return requst.get(url)
}

// 获取激活数据
export const getROVActivityDataApi = id => {
    const url = `/monitor/rov/activity/list?rovId=${id}`
    return requst.get(url)
}

// 提交总结
export const postROVCommentApi = commentData => {
    const url = `/monitor/rov`
    return requst.post(url, { ...commentData })
}

// 修改总结
export const putROVCommentApi = (commentData, id) => {
    const url = `/monitor/rov`
    return requst.put(url, { ...commentData, id })
}

// 提交激活
export const postROVActivityDataApi = (activityData, id) => {
    const url = `/monitor/rov/activity/addOrUpdateBatch/${id}`
    return requst.post(url, activityData)
}
